













































































































































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import {GlobalAuthority, AuthorityNum} from '@/common/authority';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes} from '@/model/dto/res/contents/get-category-list-res';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class CategoryExpansionPanel extends Vue {
  /** Data **/
  private category: string = '';
  private id: string = '';
  private onContentsLoad: boolean = false;
  private pageLimit: number = 3;
  private categoryId: number = 0;
  private isOnPanelClick: boolean = false;

  /** Computed **/
  get categoryInfo() {
    const panel: number | null = contentsModule.panelNo;
    let result: GCICategoryListRes[] = [];
    const arr = _.find(appModule.categoryInfo, (val: GCICategoryListRes) => {
      return _.includes(this.$route.path.slice(1).split('/'), String(val.category_type));
    });
    if (this.$route.path !== '/' && arr !== undefined) {
      result.push(arr as unknown as GCICategoryListRes);
    } else {
      result = appModule.categoryInfo as unknown as GCICategoryListRes[];
    }
    if (typeof panel === 'number' && panel !== null && result.length > 0 && appModule.categoryInfo[panel].category_id !== this.categoryId) {
      this.setContentsInfo(appModule.categoryInfo[panel].category_id);
    }
    return result;
  }

  get contents() {
    return detailModule.contents;
  }

  get userId() {
    return userModule.userId;
  }

  get userType() {
    return userModule.type;
  }

  get isAuthorityNumber() {
    return userService.isAuthorityNumber(userModule.type);
  }

  get Learner() {
    return AuthorityNum.Learner;
  }

  get contentsInfo() {
    return contentsModule.contentsInfo;
  }

  set panelNo(val: number | null) {
    contentsModule.updatePanelNo(val);
  }

  get panelNo() {
    return contentsModule.panelNo;
  }

  get innerWidth() {
    return contentsModule.innerWidth;
  }

  get text() {
    return {
      public: GlobalConstants.TEXT.PUBLIC,
      deallow: GlobalConstants.TEXT.DEARROW,
      create: GlobalConstants.TEXT.CREATE,
      notfound: GlobalConstants.TEXT.NOTFOUND,
      feedback: GlobalConstants.TEXT.FEEDBACK
    };
  }

  get isError() {
    return appModule.isError;
  }

  /** Watch **/
  @Watch('contents')
  private onChangeContents(): void {
    const token = this.$route.query.token ?? userModule.apiToken;
    if (this.id !== null) {
      const path = contentsModule.isEditMode ? `c/${this.category}/edit/${this.id}` : `c/${this.category}/${this.id}`;
      this.$router.push({
        path: `${path}`
      });
    } else {
      const path = contentsModule.isEditMode ? `c/${this.category}/edit/` : `c/${this.category}`;
      this.$router.push({ path: `${path}` });
    }
  }

  /** Methods **/
  private getTitle(idx: number): string {
    const contents: GCIContentsListRes = contentsModule.contentsInfo[idx];
    let title: string = contents.title_new !== null && contents.title_new !== '' ? contents.title_new : contents.title;
    title = this.userId === '' || this.userId !== detailModule.contents.user_id && this.isAuthorityNumber > this.Learner ? detailModule.contents.title : title;
    title = this.userId === '' || this.userId !== contents.user_id && this.isAuthorityNumber >= this.Learner ? contents.title : title;
    return title;
  }

  private formatDate(idx: number): string {
    const contents: GCIContentsListRes = contentsModule.contentsInfo[idx];
    const date = contents.published ?? contents.created;
    return date;
  }

  private async setContentsInfo(categoryId: number) {
    this.categoryId = categoryId;
    contentsModule.clearContentsInfo();
    await contentsModule.requestContentsInfo({
      c: categoryId,
      q: appModule.searchKeyword !== '' ? appModule.searchKeyword : '',
      s: 0,
      o: 'dp',
      n: this.pageLimit
    }).catch(err => {
      this.errorPropagation(err);
    });
    this.onContentsLoad = true;
    appModule.updateSearchKeyword('');
    this.isOnPanelClick = false;
  }

  private async onSelected(contents: GCIContentsListRes, category: string) {
    this.category = category;
    this.id = contents.content_id;
    contentsModule.pushIsEditMode(false);
    detailModule.pushContents(contents);
  }

  private onEdit(contents: GCIContentsListRes, category: string) {
    this.category = category;
    this.id = contents.content_id;
    contentsModule.pushIsEditMode(true);
    detailModule.pushContents(contents);
  }

  private onAdd(categoryType: string, categoryId: number, categoryName: string) {
    if (userModule.userId === null) { return; }
    this.category = categoryType;
    this.id = 'newpost';
    const contents: GCIContentsListRes = {
      category_id: categoryId,
      category_name: categoryName,
      category_type: categoryType,
      content_id: 'newpost',
      user_id: userModule.userId,
      user_name: userModule.userName,
      title: '',
      title_new: '',
      text: '',
      text_new: '',
      status: 0,
      created: '',
      updated: null,
      published: null,
      vote: [{ user_id: userModule.userId, value: false }],
      deleted: false,
      hashtag: [],
      feedback: []
    };
    contentsModule.pushIsEditMode(true);
    detailModule.pushContents(contents);
  }

  private async onPanelClick(param: GCICategoryListRes) {
    const token = this.$route.query.token ?? appModule.token;
    this.isOnPanelClick = true;
    let cid = param.category_order;
    if (
      +this.$route.query.cid === param.category_order &&
      this.$route.name === 'route-viewer'
    ) { cid = 0; }
    this.$router.push({
      path: '/',
      query: {
        token: `${token}`,
        cid: `${cid}`
      }
    });
    const func = _.debounce(() => {
      this.isOnPanelClick = false;
    }, 2000);
    func();
  }

  private onSearch(data: any, category: string) {
    const token = this.$route.query.token ?? userModule.apiToken;
    const path = `s/${data.category_id}`;
    this.$router.push({
      path: `/${path}`,
      query: {
        searchtype: 'category',
        categoryname: data.category_name
      }
    }).catch(err => err);

  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    appModule.stopLoading();
    console.log(err);
    return err;
  }

}
